

























import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import { deepRegion } from '@/utils/common'
import widgetCommon from './widgetCommon'
import {AppModule} from '@/store/modules/app'
import widgetPop from './widgetPop'
@Component({
  components: {
  }
})
export default class extends Mixins(widgetCommon, widgetPop) {
  private get value () {
    let v = this.form[this.item.businessId]
    return v ? v.join('/') : ''
  }
  private get options () {
    return deepRegion(this.$store.state.app.region, 1, this.item.regionType)
  }
  public mounted () {
    this.initField()
    AppModule.getRegionAll()
  }
  private confirm (val) {
    if (this.item.regionType === 1) {
      // 只有省的时候
      this.form[this.item.businessId] = [val.text]
    } else {
      this.form[this.item.businessId] = val.filter(one => one)
    }
    this.changeStatus(false)
  }
  private open () {
    if (this.disabled) {
      return 
    }
    this.changeStatus(true)
    this.$nextTick(() => {
      let picker = this.$refs.picker as any
      picker.setValues(this.form[this.item.businessId])
    })
  }
  private initField () {
    if (this.isUndef(this.form[this.item.businessId])) {
      this.form[this.item.businessId] = []
    }
  }

}

